/* Vionine — urun karti butonu (24.09). Gecko'nun kart butonu gorselin icinde JS ile ve hover'da basiliyordu; guvenilmez.
   Kartta kendi butonumuz var (snippets/product-grid-item1.liquid, .vio-card__btn):
   - tek varyant + stokta: sepete ekler (/cart/add.js), mini sepeti acar; acamazsa /cart'a gider
   - cok varyant: urun sayfasina gider (normal baglanti)
   - tukendi: pasif
   20.10: vio-product-shelf raflarinda Gecko lazyload gorseli yuklemezse (bolum Gecko kabugu disinda) src elle doldurulur. */
(function () {
  if (window.__vioCardBtn) return; window.__vioCardBtn = true;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var t = document.querySelector('[data-drawer-options*="mini_cart"]');
    if (t) { t.click(); return true; }
    return false;
  }
  function shelfImgs() {
    document.querySelectorAll('.vps img[data-pr-img][data-src]').forEach(function (img) {
      if (img.dataset.vioSrc) return;
      if (img.currentSrc && img.currentSrc.indexOf('data:') !== 0) return;
      img.dataset.vioSrc = '1';
      var u = img.dataset.src.replace(/width=1(?!\d)/, 'width=600');
      img.srcset = u.replace('width=600', 'width=400') + ' 400w, ' + u + ' 600w, ' + u.replace('width=600', 'width=800') + ' 800w';
      img.sizes = '(max-width: 767px) 46vw, 240px';
      img.src = u;
      img.classList.add('lazyloadt4sed');
      var l = img.parentNode && img.parentNode.querySelector('.lazyloadt4s-loader'); if (l) l.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(shelfImgs, 800); }); else setTimeout(shelfImgs, 800);
  window.addEventListener('load', function () { setTimeout(shelfImgs, 400); });
  document.addEventListener('shopify:section:load', function () { setTimeout(shelfImgs, 400); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vio-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled || b.dataset.busy) return;
    var label = b.textContent; b.dataset.busy = '1'; b.textContent = 'Adding...';
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.dataset.vioAdd, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        delete b.dataset.busy;
        if (!res.ok) { b.textContent = 'Sold out'; b.disabled = true; return; }
        b.textContent = 'Added'; setTimeout(function () { b.textContent = label; }, 1600);
        if (!openCart()) window.location.href = root() + 'cart';
      })
      .catch(function () { delete b.dataset.busy; b.textContent = label; });
  });
})();
